import { memo } from 'react';
import { makeStyles } from '@mui/styles';
import { useLocation } from 'react-router-dom';
import { AlertBoxMsg } from '@qrios/frontend-library';
import { Button, Typography, Box } from '@mui/material';

import { authentication } from '../../../authentication';
import { RADIUS } from '../../../../styles/themes';
import type { LogoutMessage } from '../../../authentication/authentication';

const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(4)
  },
  button: {
    backgroundColor: '#006941',
    padding: '8px',
    fontSize: '14px',
    height: '24px',
    border: 'none',
    color: '#fff',
    width: '420px',
    textTransform: 'initial',
    '&:hover': {
      backgroundColor: '#05472d'
    }
  }
}));

const LogoutRedirect = () => {
  const location = useLocation<{ message: LogoutMessage }>();
  const classes = useStyles();

  const alert =
    location?.state?.message && location?.state?.message.text !== '' ? (
      <Box pb={3}>
        <AlertBoxMsg severity={location.state.message.severity}>
          <Box display="flex" flexDirection="column">
            <Box>
              {location?.state?.message?.text ? (
                <span>
                  <b>Error! {location?.state?.message?.text}</b>
                </span>
              ) : null}
            </Box>
            {location?.state?.message?.correlationId ? (
              <Box>
                <span>(Correlation Id: {location?.state?.message?.correlationId})</span>
              </Box>
            ) : null}
          </Box>
        </AlertBoxMsg>
      </Box>
    ) : null;

  return (
    <Box className={classes.container}>
      {alert}
      <Box pb={2}>
        <Typography>You were logged out from the application.</Typography>
      </Box>
      <Button
        variant="contained"
        className={classes.button}
        // themed buttons are less rounded, this call to action is a pill on purpose
        sx={{ borderRadius: `${RADIUS.pill}px` }}
        onClick={authentication.loginRedirect}
        data-testid="button-redirect"
      >
        Redirect to log in form.
      </Button>
    </Box>
  );
};

export default memo(LogoutRedirect);
